import React, { useLayoutEffect, useState } from "react";
import {
  Layout,
  Card,
  Row,
  Col,
  Form,
  Input,
  Button,
  Spin,
  Select,
  DatePicker,
} from "antd";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { postAPI, displayMessage } from "../../utils/common";
import {
  CREATE_DISCOUNT_COUPON,
  EDIT_DISCOUNT_COUPON,
  DISCOUNT_COUPON_BY_ID,
} from "../../constants/api";
import { useNavigate, useParams } from "react-router-dom";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import dayjs from "dayjs";
import { RollbackOutlined } from "@ant-design/icons";

function DiscountCouponForm() {
  const { Content } = Layout;
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    if (id) getCouponDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCouponDetail = () => {
    setLoading(true);
    const data = { id };
    postAPI(
      DISCOUNT_COUPON_BY_ID,
      data,
      (res) => {
        if (res.status === true) {
          const coupon = res.data;
          form.setFieldsValue({
            title: coupon.title,
            discount_code: coupon.discount_code,
            discount_type: coupon.discount_type,
            discount_value: coupon.discount_value,
            discount_exp_date: dayjs(coupon.discount_exp_date),
          });
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
        setLoading(false);
      },
      () => {
        displayMessage(ERROR_MSG_TYPE, "Unable to fetch data");
        setLoading(false);
      }
    );
  };

  const handleSubmit = (values) => {
    setLoading(true);
    const data = {
      ...values,
      discount_exp_date: values.discount_exp_date.format(),
    };
    const api = id ? EDIT_DISCOUNT_COUPON : CREATE_DISCOUNT_COUPON;
    if (id) data.id = id;

    postAPI(
      api,
      data,
      (res) => {
        if (res.status === true) {
          displayMessage(SUCCESS_MESSAGE, res.message);
          navigate("/master/discount-coupon");
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
        setLoading(false);
      },
      () => {
        displayMessage(ERROR_MSG_TYPE, "Unable to save data");
        setLoading(false);
      }
    );
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title={id ? "Edit Discount Coupon" : "Add Discount Coupon"}
          extra={
            <Button
              style={{
                marginTop: "5px",
                marginBottom: "5px",
              }}
              onClick={() => navigate(-1)}
              type="primary"
              ghost
            >
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item
                    name="title"
                    label="Name"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="discount_code"
                    label="Code"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="discount_type"
                    label="Discount Type"
                    rules={[{ required: true }]}
                  >
                    <Select>
                      <Select.Option value="percentage">
                        Percentage
                      </Select.Option>
                      <Select.Option value="fixed">Fixed</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="discount_value"
                    label="Value"
                    rules={[{ required: true }]}
                  >
                    <Input type="number" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="discount_exp_date"
                    label="End Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    {id ? "Update" : "Create"}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default DiscountCouponForm;
